import { render } from "./AboutTitleSection.vue?vue&type=template&id=62edbfcc&scoped=true"
import script from "./AboutTitleSection.vue?vue&type=script&lang=js"
export * from "./AboutTitleSection.vue?vue&type=script&lang=js"

import "./AboutTitleSection.vue?vue&type=style&index=0&id=62edbfcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62edbfcc"]])

export default __exports__